/**
 * @description
 */
import * as postPartnership from './postPartnership';
import * as putPartnershipById from './putPartnershipById';

export { postPartnership, putPartnershipById };
